/**
 * 참가비 카드 제목 옆 상태 배지.
 * @description 조건부(회차 없음)는 단계 배지(`Minimum reached` · `Going ahead` …), 그 밖에는 카드
 *   상태 배지(`Confirmed` · `Released`)다. 받는 중(모으는 중 · 마감 직후 판정 대기)은 평소 상태라
 *   그리지 않는다(앱 `CollabFeeStatusBadge` · `CollabConditionalBadge`).
 * @example feeBadgeOf(fee) // { text: "Going ahead", tone: "success" }
 */
import { COLLAB_V3_CARD_COPY } from "../constants/collabV3CardCopy";
import type { CollabV3ConditionalState, CollabV3Fee } from "../entities";

interface FeeBadge {
  text: string;
  tone: "success" | "neutral";
}

const copy = COLLAB_V3_CARD_COPY.fee;

const CONDITIONAL_BADGES: Partial<Record<CollabV3ConditionalState, FeeBadge>> =
  {
    minReached: { text: copy.cond.badge.minReached, tone: "success" },
    full: { text: copy.cond.badge.full, tone: "neutral" },
    committed: { text: copy.cond.badge.committed, tone: "success" },
    notReached: { text: copy.cond.badge.notReached, tone: "neutral" },
    cancelled: { text: copy.cond.badge.cancelled, tone: "neutral" },
  };

export function feeBadgeOf(fee: CollabV3Fee): FeeBadge | null {
  if (fee.conditionalState) {
    return CONDITIONAL_BADGES[fee.conditionalState] ?? null;
  }
  if (fee.status === "COMMITTED") {
    return { text: copy.badge.committed, tone: "success" };
  }
  if (fee.status === "REFUNDED") {
    return { text: copy.badge.refunded, tone: "neutral" };
  }
  return null;
}
